import clsx from 'clsx';
import { Link } from 'react-router-dom';

interface AssociatedEntityComponentProps {
  className?: string;
  system_name: string;
  link: string;
}
export function AssociatedEntityComponent({
  className,
  system_name,
  link
}: AssociatedEntityComponentProps) {
  const baseClassList = [
    'bg-white',
    'border-[1px]',
    'font-size-[15px]',
    'font-weight-[600]',
    'px-[16px]',
    'rounded-md',
    'm-2'
  ];

  return (
    <Link
      className={clsx(
        baseClassList,
        className,
        link
          ? 'border-navy text-navy hover:underline'
          : 'border-black text-black hover:cursor-default'
      )}
      to={link}
    >
      {system_name}
    </Link>
  );
}
